import useFetchApi from "@/api/hooks/useFetchApi";
import BreadCrumb from "@/components/BreadCrumb";
import GalleryCard from "@/components/Cards/GalleryCard";
import Loader from "@/components/Loader/loader";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ListGallery: React.FC = () => {

    const [selectedImage, setSelectedImage] = useState<{ src: string; title: string } | null>(null);
    const [breadcrumbChild, setBreadcrumbChild] = useState<string>("");
    const { category } = useParams<{ category: string }>();

    const handleOpenImage = (src: string, title: string) => {
        setSelectedImage({ src, title });
    };

    const handleCloseImage = () => {
        setSelectedImage(null);
    };

    const {
        data,
        isLoading,
        error
    } = useFetchApi({
        url: "/v1/gp/67876544d187a284903c5f92/tr/find?list_related=false&list_referenced=false&module_populate=6787657cd187a284903c612c&limit=0&skip=0",
        service: "CMS_PROC"
    });

    useEffect(() => {
        if (data && data.title) {
            setBreadcrumbChild(data.title);
        }
    })

    return (
        <>
            <BreadCrumb title="Galeri" parent="Galeri" child={breadcrumbChild} />

            {(isLoading === false && data) ? (
                <>
                    <GalleryCard data={data} isLoading={isLoading} category={category} />
                </>
            ) : <><Loader /></>
            }
        </>
    )
}

export default ListGallery;